export const iconFontAwesomeFoodBeverageCloudMeatball = (
	<i className="fa-solid fa-cloud-meatball"></i>
);
